module.exports = __webpack_public_path__ + "static/media/irishpension.c46efa1c.png";